import { fetchData } from 'framework/api/fetch-data';
import { getApiUrl } from 'config';
import { featuresToPromoteConfig } from './config';
import { IDefaultRetailerSettingsVersion2, IMobileSettings, ISharedSettings } from '@thryveai/theme-interfaces';
import { checkFeaturesForPromotion } from './utils';

const getSettings = async <T>(ref: string): Promise<T> => {
  let cmsContent: T = {} as T;
  let documentId = '';
  let variantId = '';

  const retailerSettingsIds = await fetchData<{ id: string; variantIds: string[] }>({
    url: getApiUrl(`cms/documents/${ref}`),
  });

  if (retailerSettingsIds) {
    documentId = retailerSettingsIds.data.id;
    [variantId] = retailerSettingsIds.data.variantIds;

    const settingsContent = await fetchData<{ cmsContent: { data: T } }>({
      url: getApiUrl(`cms/documents/${documentId}/variants/${variantId}/content`),
    });
    if (settingsContent) {
      cmsContent = settingsContent.data.cmsContent.data;
    }
  }
  return cmsContent;
};

export const fetchFeaturesToPromote = async () => {
  try {
    const [storefrontData, mobileData, sharedData] = await Promise.allSettled([
      Object.keys(featuresToPromoteConfig.storefront).length > 0
        ? getSettings<{ [key: string]: IDefaultRetailerSettingsVersion2 }>('terms_storefront_settings')
        : Promise.resolve({}),
      Object.keys(featuresToPromoteConfig.mobile).length > 0
        ? getSettings<{ [key: string]: IMobileSettings }>('term_mobile_app_v2_settings')
        : Promise.resolve({}),
      Object.keys(featuresToPromoteConfig.shared).length > 0
        ? getSettings<{ [key: string]: ISharedSettings }>('terms_shared_settings')
        : Promise.resolve({}),
    ]);

    const storefront =
      storefrontData.status === 'fulfilled'
        ? checkFeaturesForPromotion(Object.values(storefrontData.value), featuresToPromoteConfig.storefront)
        : [];

    const mobile =
      mobileData.status === 'fulfilled'
        ? checkFeaturesForPromotion(Object.values(mobileData.value), featuresToPromoteConfig.mobile)
        : [];

    const shared =
      sharedData.status === 'fulfilled'
        ? checkFeaturesForPromotion(Object.values(sharedData.value), featuresToPromoteConfig.shared)
        : [];

    return {
      storefront,
      mobile,
      shared,
    };
  } catch (error) {
    console.error('Error fetching settings:', error);
    return {
      storefront: [],
      mobile: [],
      shared: [],
    };
  }
};
